"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "WinterCheckout", {
  enumerable: true,
  get: function get() {
    return _WinterCheckout.default;
  }
});

var _WinterCheckout = _interopRequireDefault(require("./components/WinterCheckout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }